import { apiRequest } from './apiClient.js'

export const usersService = {
  list: (options = {}) => apiRequest('/api/users/list', options),
  info: (options = {}) => apiRequest('/api/user/info', options),
  avatar: (userId, options = {}) => apiRequest(`/api/users/${encodeURIComponent(userId)}/avatar`, options),
  remove: (userId, options = {}) => apiRequest(`/api/users/${encodeURIComponent(userId)}`, options),
  createTest: (options = {}) => apiRequest('/api/users/create-test', options),
  removeAll: (options = {}) => apiRequest('/api/users/delete-all', options),
  adminList: (options = {}) => apiRequest('/api/users/list', options),
  adminAvatar: (userId, options = {}) => apiRequest(`/api/users/${encodeURIComponent(userId)}/avatar`, options),
  botLimitDetails: (userId, options = {}) => apiRequest(`/api/users/${encodeURIComponent(userId)}/bot-limit`, { ...options, responseContract: 'customer_bot_limit_response' }),
  updateBotLimit: (userId, payload) => apiRequest(`/api/users/${encodeURIComponent(userId)}/bot-limit`, { method: 'PUT', body: JSON.stringify(payload), timeoutMs: 180000, responseContract: 'customer_bot_limit_response' }),
}
